import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ title, subtitle, children, delay = 0 }) => (
	<motion.div
		initial={{ opacity: 0, y: 20 }}
		whileInView={{ opacity: 1, y: 0 }}
		viewport={{ once: true, amount: 0.3 }}
		transition={{ duration: 0.5, delay }}
		whileHover={{ y: -4 }}
		className="rounded-xl shadow-md text-white p-6 sm:p-8 md:p-10 lg:p-12 text-center"
		style={{
			background: 'conic-gradient(from 72.08deg at 48.19% 17.39%, #113861 -131.54deg, #113861 0.39deg, rgba(17, 56, 97, 0.5) 141.45deg, #113861 228.46deg, #113861 360.39deg)'
		}}
	>
		<h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#fff] font-source font-regular text-center mb-2 sm:mb-3 leading-tight">
			{title} <br /> <span className="italic">Opportunities</span>
		</h3>
		<p className="text-sm sm:text-base md:text-md lg:text-lg leading-relaxed text-center font-sans font-regular text-[#fff]">{children}</p>
	</motion.div>
);

const Opportunities = () => {
	return (
		<section className="relative bg-white py-8 sm:py-10 md:py-12 lg:py-14">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
				<h2 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl text-[#113861] mb-6 sm:mb-8">
					<span className="font-source italic text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mr-1 sm:mr-2 leading-tight">Opportunities</span>
					<span className="align-middle font-source font-regular text-[#113861] text-lg sm:text-xl md:text-2xl lg:text-3xl">@Analytical Prism</span>
				</h2>
				<div className="mt-6 sm:mt-8 md:mt-10 lg:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
					<Card title="Employment" delay={0}>
						We are seeking talented individuals across research, consulting, data analytics, business development, and
						technology. Whether you are a cognitive scientist, a marketing strategist, or a data analyst, Analytical Prism
						provides a space where your expertise can create a meaningful impact.
					</Card>
					<Card title="Research" delay={0.1}>
						You will have the opportunity to collaborate with leading academics and industry experts on real-world projects,
						allowing you to gain valuable insights and practical experience. Additionally, you'll gain access to exclusive
						research opportunities, as well as workshops and mentorship programs that can enhance your skills and knowledge.
						Contribute to high-impact initiatives that shape education and workforce policies, making a meaningful difference
						in the field.
					</Card>
					<Card title="Internship" delay={0.2}>
						We believe in nurturing the next generation of thinkers, researchers, and leaders. Our internship and research
						programmes provide students and early-career professionals with hands-on experience in cognitive science,
						behavioural research, education policy, and data-driven decision-making.
					</Card>
				</div>
			</div>
		</section>
	);
};

export default Opportunities;


